document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.carousel-dots').forEach(dotContainer => {
    const carouselId = dotContainer.dataset.controls;
    const carousel = document.getElementById(carouselId);

    if (!carousel) return;

    const slides = carousel.querySelectorAll('[id^="Slide-"], product-card');
    const dotButtons = [];
    
    // Function to calculate visible items and required dots
    const updateDotsVisibility = () => {
      const carouselRect = carousel.getBoundingClientRect();
      const slideWidth = slides[0].offsetWidth;
      const visibleItems = Math.floor(carouselRect.width / slideWidth);
      const totalItems = slides.length;
      
      // Clear existing dots
      dotContainer.innerHTML = '';
      dotButtons.length = 0;
      
      // Only create dots if there are more items than visible
      if (totalItems > visibleItems) {
        const dotsNeeded = Math.ceil(totalItems / visibleItems);
        
        for (let i = 0; i < dotsNeeded; i++) {
          const dot = document.createElement('button');
          dot.className = 'carousel-dot';
          if (i === 0) dot.classList.add('active');
          
          dot.addEventListener('click', () => {
            // Scroll to the first slide of this dot's group
            const targetIndex = i * visibleItems;
            const targetSlide = slides[targetIndex];
            targetSlide.scrollIntoView({ 
              behavior: 'smooth', 
              inline: 'start', 
              block: 'nearest' 
            });

            // Update active state
            dotButtons.forEach(btn => btn.classList.remove('active'));
            dot.classList.add('active');
          });

          dotContainer.appendChild(dot);
          dotButtons.push(dot);
        }
      }
    };

    // Initial setup
    updateDotsVisibility();

    // Update dots on resize (for responsive behavior)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateDotsVisibility, 250);
    });

    // Keep dots in sync when carousel scrolls
    carousel.addEventListener('scroll', () => {
      if (dotButtons.length === 0) return;
      
      const scrollLeft = carousel.scrollLeft;
      const slideWidth = slides[0].offsetWidth;
      const carouselRect = carousel.getBoundingClientRect();
      const visibleItems = Math.floor(carouselRect.width / slideWidth);
      
      const currentGroup = Math.floor(scrollLeft / (slideWidth * visibleItems));
      
      dotButtons.forEach((btn, i) => {
        btn.classList.toggle('active', i === currentGroup);
      });
    });
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   // Observe when user clicks on any Variant King swatch
//   document.body.addEventListener("click", function (e) {
//     const swatch = e.target.closest(".swatch-group-selector");
//     if (!swatch) return;

//     // Give Variant King time to update the DOM
//     setTimeout(() => {
//       document.querySelectorAll("product-card, .product-card").forEach((card) => {
//         const salePrice = card.querySelector("sale-price");
//         if (salePrice && !salePrice.querySelector(".custom-text")) {
//           const span = document.createElement("span");
//           span.className = "custom-text";
//           span.textContent = "à vista no cartão";
//           salePrice.appendChild(span);
//         }
//       });
//     }, 300); // delay ensures Variant King has finished replacing prices
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  function restoreCustomLabels() {
    document.querySelectorAll("product-card, .product-card").forEach((card) => {
      const salePrice = card.querySelector("sale-price");
      if (salePrice && !salePrice.querySelector(".custom-text")) {
        // Reinsert "à vista no cartão"
        const span = document.createElement("span");
        span.className = "custom-text";
        span.textContent = "à vista no cartão";
        salePrice.appendChild(span);
      }

      // Recreate Pix price wrapper if removed
      if (!card.querySelector(".pix-price-wrapper")) {
        const productPrice = salePrice?.textContent?.replace(/[^\d,]/g, "").replace(",", ".") || null;
        const pixWrapper = document.createElement("div");
        pixWrapper.className = "pix-price-wrapper";
        pixWrapper.innerHTML = `
          <span class="text-on-sale" style="font-size: 1.2em; color: #17aac4;">
            ${(productPrice ? (parseFloat(productPrice) * 0.94).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "")}
            <span style="font-size: 0.9em;"> no Pix</span>
          </span>
          <a style="margin-left: 0px;">  
            <span style="background-color: #c46618;padding: 5px 5px;color: white;font-size: 0.7em;border-radius: 10px;font-weight: bold;">6% OFF</span>
          </a>
        `;
        const priceList = card.querySelector("price-list");
        if (priceList) priceList.insertAdjacentElement("afterend", pixWrapper);
      }
    });
  }

  // Hook on Variant King swatch clicks
  document.body.addEventListener("click", (e) => {
    const swatch = e.target.closest(".swatch-group-selector");
    if (!swatch) return;

    // Wait a bit for Variant King to update DOM
    setTimeout(restoreCustomLabels, 400);
  });

  // Also restore when sections are reloaded or AJAX navigation occurs
  document.addEventListener("shopify:section:load", restoreCustomLabels);
  document.addEventListener("shopify:section:select", restoreCustomLabels);
  document.addEventListener("shopify:section:reorder", restoreCustomLabels);

  // Initial render fix
  restoreCustomLabels();
});

